/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Number = (function () {

    function NumberField () {

        Monet.UI.Fields.TextField.apply (this, arguments);

        //set default options and bound
        this.options = { allowNegative: false, allowZero: true };
        this.min = 0;
        this.regexp = /(-+)|[^0-9]/;
        this.suffix = null;

        this.setOptions = function (options) {
            Object.assign(this.options, options);

            //allowNegative always allow 'zero' too
            if (this.options.allowNegative) {
                this.min = -1000;
                this.regexp = /(?!^-[1-9]+)[^0-9]/g;
            } else if (!this.options.allowZero) {
                this.min = 1;
                this.regexp = /(-+)|(^0+$)|[^0-9]/;
            }
        };

        this.setMeta = function (meta) {
            if(meta && typeof meta === 'string'){
                meta = JSON.parse(meta);
                this.setOptions(meta);
            }
            this.meta = meta;
        };

        this.setSuffix = function() {
            if(this.meta && this.meta.suffix) {
                this.suffix = this.meta.suffix;
            }
        }

        this.getValue = function () {

            let value = this.input.value;

            if (value) {
                return parseInt (this.input.value, 10);
            }

            return value;

        };

        this.createElement = function () {

            this.input = document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'numberPicker';

            //"Max integer value, in Java, is 2147483647."
            this.input.maxLength = 9;

            if(this.suffix) {
                this.rootEl.className = "numberPickerSuffixed";
                this.input.className = "";
                const suffixlabel = document.createElement("label");
                suffixlabel.className = "suffix";
                const suffixTextNode = document.createTextNode(Monet.I18n.getResourcesByKey(this.suffix));
                suffixlabel.appendChild(suffixTextNode);

                this.rootEl.appendChild(this.input);
                this.rootEl.appendChild(suffixlabel);
            } else {
                this.rootEl.appendChild(this.input);
            }
        };

        this.initializeSpecialBehavior = function () {
            $(this.input).stepper({ limit: [this.min, 1000] });
        };

        this.addEventListeners = function () {
            //workaround to allow hifen char which is blocked by jquery stepper
            this.input.addEventListener("keydown", (e) => {
                if (this.options.allowNegative && e.which == 189 ) {
                    e.stopPropagation();
                }
            });

            this.input.addEventListener("input", () => {
                if (this.input.value.match(this.regexp) && ((this.options.allowNegative && this.input.value != '-') || !this.options.allowNegative)) {
                    this.input.value = this.input.value.replace(this.regexp, '');
                }
            });

            const fixInvalidInput = () => {
                if (isNaN(this.input.value) || this.input.value == '-') {
                    this.input.value = '';
                }
            };

            this.input.addEventListener("blur", fixInvalidInput);
            const stepperContainer = this.rootEl.querySelector('.stepper-wrap');
            stepperContainer && stepperContainer.addEventListener("mousedown", fixInvalidInput);
        };

        this.render = function () {
            this.setSuffix();
            this.createElement();
            this.initializeSpecialBehavior();
            this.addEventListeners();
            this.setInputValue();
            return this.rootEl;

        };

    }

    return NumberField;

}());